export default "__VITE_ASSET__BtPEPAJ9__"